var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { name: "news-modal" },
      on: { "before-close": _vm.onBeforeClose }
    },
    [
      _c("div", { staticClass: "news-modal" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c(
              "flex-grid",
              { attrs: { "align-items": "center" } },
              [
                _c("flex-grid-item", { attrs: { grow: "1" } }, [
                  _c("h2", [_vm._v("What's new")])
                ]),
                _vm._v(" "),
                _c(
                  "flex-grid-item",
                  { attrs: { width: "40px" } },
                  [
                    _c("button-icon", {
                      attrs: { icon: "icon_delete-thin", size: "30px" },
                      on: { click: _vm.onDismissClick }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.newsItems, function(ref) {
            var id = ref.id
            var image = ref.image
            var summary = ref.summary
            var title = ref.title
            var url = ref.url
            return _c("div", { key: id, staticClass: "news-item" }, [
              _c(
                "h3",
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: url },
                      nativeOn: {
                        click: function($event) {
                          return _vm.onLinkClick.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n            " + _vm._s(title) + "\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(summary))]),
              _vm._v(" "),
              image
                ? _c("img", {
                    staticClass: "news-image",
                    attrs: { alt: "news image", src: image }
                  })
                : _vm._e()
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "flex-grid",
              { attrs: { "align-items": "center" } },
              [
                _c(
                  "flex-grid-item",
                  { attrs: { grow: "1" } },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "see-more",
                        attrs: { to: { name: "news" } },
                        nativeOn: {
                          click: function($event) {
                            return _vm.onLinkClick.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("\n            See more news . . .\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "flex-grid-item",
                  { attrs: { width: "102px" } },
                  [
                    _c("button-fill", {
                      attrs: { label: "DISMISS" },
                      on: { click: _vm.onDismissClick }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bb27316", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb27316","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/news-modal.vue
// module id = 1346
// module chunks = 0